import { BeaconComponentRegistryChannel } from '@tableau/omnibox-common/lib/src/channelDefinitions/BeaconComponentRegistryChannel';

import { getBeaconComponentRegistry } from '~src/beacon/BeaconComponentRegistry';
import { getBeaconComponents } from '~src/beacon/BeaconComponentRegistryFunctions';

export function startListening(): () => void {
    const beaconComponentRegistryChannel = new BeaconComponentRegistryChannel();
    const stopListeningBeaconComponentRegistryChannel = beaconComponentRegistryChannel.listen((request) => {
        const beaconComponentRegistry = getBeaconComponentRegistry();
        const beaconComponents = getBeaconComponents(beaconComponentRegistry, request.searchTerm);
        return { beaconComponentRegistry : beaconComponents };
    });

    return () => {
        stopListeningBeaconComponentRegistryChannel();
    };
}
